import { HttpClientModule } from '@angular/common/http';
import { Component, InjectionToken, Inject, Directive, ElementRef, EventEmitter, Output, Injectable, Optional, ViewChild, HostListener, NgModule } from '@angular/core';
import { DOCUMENT, CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@ngx-translate/core';
import * as ɵngcc2 from '@angular/common';

const _c0 = ["stickyToast"];
function NotificationBarComponent_div_2_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵlistener("click", function NotificationBarComponent_div_2_div_6_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const notification_r2 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r5.hideNotification(notification_r2)); });
    ɵngcc0.ɵɵtext(1, "\u00D7");
    ɵngcc0.ɵɵelementEnd();
} }
function NotificationBarComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div")(1, "div", 3);
    ɵngcc0.ɵɵelement(2, "img", 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 5)(4, "div", 6);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, NotificationBarComponent_div_2_div_6_Template, 2, 0, "div", 7);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const notification_r2 = ctx.$implicit;
    ɵngcc0.ɵɵclassMapInterpolate1("notification notification-", notification_r2.typeValue, "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵclassMapInterpolate1("logo ", notification_r2.typeValue, "");
    ɵngcc0.ɵɵpropertyInterpolate1("src", "/assets/", notification_r2.typeValue, ".png", ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(notification_r2.message);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", notification_r2.allowClose);
} }
class GraphLoadBarComponent {
}
GraphLoadBarComponent.ɵfac = function GraphLoadBarComponent_Factory(t) { return new (t || GraphLoadBarComponent)(); };
GraphLoadBarComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: GraphLoadBarComponent, selectors: [["graph-load-bar"]], decls: 5, vars: 0, consts: [[1, "bar"]], template: function GraphLoadBarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelement(1, "div", 0)(2, "div", 0)(3, "div", 0)(4, "div", 0);
        ɵngcc0.ɵɵelementEnd();
    } }, styles: ["[_nghost-%COMP%]{display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center}.bar[_ngcontent-%COMP%]{background-color:#dddfe0;float:left;margin-right:8px;width:13px;height:40px;-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out;-webkit-animation-name:loadingbar;animation-name:loadingbar}.bar[_ngcontent-%COMP%]:last-child{margin-right:0}.bar[_ngcontent-%COMP%]:nth-child(2){-webkit-animation-delay:.2s;animation-delay:.2s}.bar[_ngcontent-%COMP%]:nth-child(3){-webkit-animation-delay:.4s;animation-delay:.4s}.bar[_ngcontent-%COMP%]:nth-child(4){-webkit-animation-delay:.3s;animation-delay:.3s}@-webkit-keyframes loadingbar{0%,100%{margin-top:5px;height:35px}50%{margin-top:35px;height:5px}}@keyframes loadingbar{0%,100%{margin-top:5px;height:35px}50%{margin-top:35px;height:5px}}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GraphLoadBarComponent, [{
        type: Component,
        args: [{ selector: 'graph-load-bar', template: "<div>\n  <div class=\"bar\"></div>\n  <div class=\"bar\"></div>\n  <div class=\"bar\"></div>\n  <div class=\"bar\"></div>\n</div>\n", styles: [":host{display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center}.bar{background-color:#dddfe0;float:left;margin-right:8px;width:13px;height:40px;-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out;-webkit-animation-name:loadingbar;animation-name:loadingbar}.bar:last-child{margin-right:0}.bar:nth-child(2){-webkit-animation-delay:.2s;animation-delay:.2s}.bar:nth-child(3){-webkit-animation-delay:.4s;animation-delay:.4s}.bar:nth-child(4){-webkit-animation-delay:.3s;animation-delay:.3s}@-webkit-keyframes loadingbar{0%,100%{margin-top:5px;height:35px}50%{margin-top:35px;height:5px}}@keyframes loadingbar{0%,100%{margin-top:5px;height:35px}50%{margin-top:35px;height:5px}}"] }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const NAMESPACE_TOKEN = new InjectionToken('NamespaceToken');
class IndeterminateLoadBarComponent {
    /**
     * @param {?=} _namespace
     */
    constructor(_namespace = '') {
        this._namespace = _namespace;
        this.namespace = _namespace;
    }
}
IndeterminateLoadBarComponent.ɵfac = function IndeterminateLoadBarComponent_Factory(t) { return new (t || IndeterminateLoadBarComponent)(ɵngcc0.ɵɵdirectiveInject(NAMESPACE_TOKEN)); };
IndeterminateLoadBarComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: IndeterminateLoadBarComponent, selectors: [["indeterminate-load-bar"]], decls: 6, vars: 3, consts: [[1, "container"], [1, "description"], [1, "rail"], [1, "loadbar"]], template: function IndeterminateLoadBarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵpipe(3, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵelement(5, "div", 3);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(3, 1, ctx.namespace + "IndeterminateLoadingBar.LoadingMessage"), " ");
    } }, dependencies: [ɵngcc1.TranslatePipe], styles: ["[_nghost-%COMP%]{display:-webkit-box;display:flex;-webkit-box-pack:center;justify-content:center}.container[_ngcontent-%COMP%]{width:100%;max-width:520px;padding-left:10px;padding-right:10px}.container[_ngcontent-%COMP%]   .description[_ngcontent-%COMP%]{color:#333;font-size:12px;width:100%;text-align:center;margin-bottom:10px;font-family:ProximaNova;font-weight:400}.container[_ngcontent-%COMP%]   .rail[_ngcontent-%COMP%]{width:100%;height:3px;overflow:hidden;background-color:#ccc}.container[_ngcontent-%COMP%]   .rail[_ngcontent-%COMP%]   .loadbar[_ngcontent-%COMP%]{background-color:#2cb3ca;width:20%;height:100%;animation-duration:1s;animation-name:slidein;animation-iteration-count:infinite;animation-direction:alternate;animation-timing-function:ease-in-out;-webkit-animation-duration:1s;-webkit-animation-name:slidein;-webkit-animation-iteration-count:infinite;-webkit-animation-direction:alternate;-webkit-animation-timing-function:ease-in-out}@keyframes slidein{from{margin-left:90%}to{margin-left:-10%}}@-webkit-keyframes slidein{from{margin-left:90%}to{margin-left:-10%}}"] });
/** @nocollapse */
IndeterminateLoadBarComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [NAMESPACE_TOKEN,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IndeterminateLoadBarComponent, [{
        type: Component,
        args: [{ selector: 'indeterminate-load-bar', template: "<div class=\"container\">\n  <div class=\"description\">\n    {{namespace +  'IndeterminateLoadingBar.LoadingMessage' | translate}}\n  </div>\n  <div class=\"rail\">\n    <div class=\"loadbar\"></div>\n  </div>\n</div>\n", styles: [":host{display:-webkit-box;display:flex;-webkit-box-pack:center;justify-content:center}.container{width:100%;max-width:520px;padding-left:10px;padding-right:10px}.container .description{color:#333;font-size:12px;width:100%;text-align:center;margin-bottom:10px;font-family:ProximaNova;font-weight:400}.container .rail{width:100%;height:3px;overflow:hidden;background-color:#ccc}.container .rail .loadbar{background-color:#2cb3ca;width:20%;height:100%;animation-duration:1s;animation-name:slidein;animation-iteration-count:infinite;animation-direction:alternate;animation-timing-function:ease-in-out;-webkit-animation-duration:1s;-webkit-animation-name:slidein;-webkit-animation-iteration-count:infinite;-webkit-animation-direction:alternate;-webkit-animation-timing-function:ease-in-out}@keyframes slidein{from{margin-left:90%}to{margin-left:-10%}}@-webkit-keyframes slidein{from{margin-left:90%}to{margin-left:-10%}}"] }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [NAMESPACE_TOKEN]
            }] }]; }, null); })();
if (false) {
    /** @type {?} */
    IndeterminateLoadBarComponent.prototype.namespace;
    /**
     * @type {?}
     * @private
     */
    IndeterminateLoadBarComponent.prototype._namespace;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class EllipsisTooltipDirective {
    /**
     * @param {?} elRef
     */
    constructor(elRef) {
        this.elRef = elRef;
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        if (this.isEllipsis()) {
            this.setupTooltip();
        }
    }
    /**
     * @private
     * @return {?}
     */
    isEllipsis() {
        const { nativeElement: { offsetWidth, scrollWidth } } = this.elRef;
        return offsetWidth < scrollWidth;
    }
    /**
     * @private
     * @return {?}
     */
    setupTooltip() {
        const { nativeElement } = this.elRef;
        const { textContent } = nativeElement;
        if (textContent !== null) {
            nativeElement.setAttribute('title', textContent);
        }
    }
}
EllipsisTooltipDirective.ɵfac = function EllipsisTooltipDirective_Factory(t) { return new (t || EllipsisTooltipDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
EllipsisTooltipDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: EllipsisTooltipDirective, selectors: [["", "ellipsisTooltip", ""]] });
/** @nocollapse */
EllipsisTooltipDirective.ctorParameters = () => [
    { type: ElementRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EllipsisTooltipDirective, [{
        type: Directive,
        args: [{ selector: '[ellipsisTooltip]' }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    EllipsisTooltipDirective.prototype.elRef;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function HoverEvent() { }
if (false) {
    /** @type {?} */
    HoverEvent.prototype.el;
    /** @type {?} */
    HoverEvent.prototype.hovering;
}
class OnHoverDirective {
    /**
     * @param {?} elRef
     */
    constructor(elRef) {
        this.elRef = elRef;
        this.onHover = new EventEmitter();
        this.onMouseOver = this.onMouseOver.bind(this);
        this.onMouseOut = this.onMouseOut.bind(this);
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        this.elRef.nativeElement.addEventListener('mouseover', this.onMouseOver);
        this.elRef.nativeElement.addEventListener('mouseout', this.onMouseOut);
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.elRef.nativeElement.removeEventListener('mouseover', this.onMouseOver);
        this.elRef.nativeElement.removeEventListener('mouseout', this.onMouseOut);
    }
    /**
     * @private
     * @return {?}
     */
    onMouseOver() {
        this._onHover(true);
    }
    /**
     * @private
     * @return {?}
     */
    onMouseOut() {
        this._onHover(false);
    }
    /**
     * @private
     * @param {?} hovering
     * @return {?}
     */
    _onHover(hovering) {
        this.onHover.emit({ el: this.elRef.nativeElement, hovering });
    }
}
OnHoverDirective.ɵfac = function OnHoverDirective_Factory(t) { return new (t || OnHoverDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
OnHoverDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: OnHoverDirective, selectors: [["", "onHover", ""]], outputs: { onHover: "onHover" } });
/** @nocollapse */
OnHoverDirective.ctorParameters = () => [
    { type: ElementRef }
];
OnHoverDirective.propDecorators = {
    onHover: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OnHoverDirective, [{
        type: Directive,
        args: [{ selector: '[onHover]' }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { onHover: [{
            type: Output
        }] }); })();
if (false) {
    /** @type {?} */
    OnHoverDirective.prototype.onHover;
    /**
     * @type {?}
     * @private
     */
    OnHoverDirective.prototype.elRef;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
const NotificationType = {
    Info: 0, Success: 1, Error: 2, Warning: 3,
};
NotificationType[NotificationType.Info] = 'Info';
NotificationType[NotificationType.Success] = 'Success';
NotificationType[NotificationType.Error] = 'Error';
NotificationType[NotificationType.Warning] = 'Warning';
/**
 * @record
 */
function Notification() { }
if (false) {
    /** @type {?} */
    Notification.prototype.message;
    /** @type {?|undefined} */
    Notification.prototype.type;
    /** @type {?|undefined} */
    Notification.prototype.typeValue;
    /** @type {?|undefined} */
    Notification.prototype.autoHide;
    /** @type {?|undefined} */
    Notification.prototype.hideDelay;
    /** @type {?|undefined} */
    Notification.prototype.allowClose;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NotificationService {
    constructor() {
        this.onCreate = new EventEmitter();
    }
    /**
     * @param {?} notification
     * @return {?}
     */
    create(notification) {
        this.onCreate.emit(notification);
    }
}
NotificationService.ɵfac = function NotificationService_Factory(t) { return new (t || NotificationService)(); };
NotificationService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: NotificationService, factory: NotificationService.ɵfac });
/** @nocollapse */
NotificationService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NotificationService, [{
        type: Injectable
    }], function () { return []; }, null); })();
if (false) {
    /** @type {?} */
    NotificationService.prototype.onCreate;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const MESSAGES_CONFIG = new InjectionToken('');
class NotificationBarComponent {
    /**
     * @param {?} notificationBarService
     * @param {?} doc
     * @param {?=} config
     */
    constructor(notificationBarService, doc, config) {
        this.notificationBarService = notificationBarService;
        this.doc = doc;
        this.config = config;
        this.sticky = false;
        this.notifications = [];
        this.defaults = {
            message: '',
            type: NotificationType.Info,
            autoHide: false,
            hideDelay: 5000,
            allowClose: true
        };
        this.subscription = this.notificationBarService.onCreate.subscribe(this.addNotification.bind(this));
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        this.elementPosition = this.toast.nativeElement.offsetTop;
        ;
    }
    /**
     * @return {?}
     */
    handleScroll() {
        /** @type {?} */
        const windowScroll = window.pageYOffset;
        if (windowScroll > 0) {
            this.sticky = true;
        }
        else {
            this.sticky = false;
        }
    }
    /**
     * @param {?} notification
     * @return {?}
     */
    addNotification(notification) {
        /** @type {?} */
        const newNotification = Object.assign({}, this.defaults, notification);
        newNotification.typeValue = NotificationType[newNotification.type].toLowerCase();
        if (this.config && this.config.messages) {
            newNotification.message = this.config.messages[notification.message] || notification.message;
        }
        this.notifications.push(newNotification);
        if (newNotification.autoHide) {
            window.setTimeout((/**
             * @return {?}
             */
            () => {
                this.hideNotification(newNotification);
            }), newNotification.hideDelay);
        }
    }
    /**
     * @param {?} notification
     * @return {?}
     */
    hideNotification(notification) {
        /** @type {?} */
        const index = this.notifications.indexOf(notification);
        this.notifications.splice(index, 1);
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
NotificationBarComponent.ɵfac = function NotificationBarComponent_Factory(t) { return new (t || NotificationBarComponent)(ɵngcc0.ɵɵdirectiveInject(NotificationService), ɵngcc0.ɵɵdirectiveInject(DOCUMENT), ɵngcc0.ɵɵdirectiveInject(MESSAGES_CONFIG, 8)); };
NotificationBarComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NotificationBarComponent, selectors: [["notification-bar"]], viewQuery: function NotificationBarComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.toast = _t.first);
    } }, hostBindings: function NotificationBarComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("scroll", function NotificationBarComponent_scroll_HostBindingHandler() { return ctx.handleScroll(); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, decls: 3, vars: 2, consts: [[3, "ngClass"], ["stickyToast", ""], [3, "class", 4, "ngFor", "ngForOf"], [1, "img-wrapper"], [3, "src"], [1, "msg-wrapper"], [1, "message"], ["class", "close-click", 3, "click", 4, "ngIf"], [1, "close-click", 3, "click"]], template: function NotificationBarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵtemplate(2, NotificationBarComponent_div_2_Template, 7, 9, "div", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ctx.sticky ? "sticky" : "sticky-top");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.notifications);
    } }, dependencies: [ɵngcc2.NgClass, ɵngcc2.NgForOf, ɵngcc2.NgIf], styles: ["[_nghost-%COMP%]{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column}.sticky[_ngcontent-%COMP%]{position:fixed;top:0;overflow:hidden;z-index:10;width:100%}.sticky-top[_ngcontent-%COMP%]{position:fixed;top:60px;overflow:hidden;z-index:10;width:100%}.notification[_ngcontent-%COMP%]{position:relative;text-align:left;padding-left:50px;padding-top:15px;height:50px;font-size:16px;line-height:18px;color:#333}.logo[_ngcontent-%COMP%]{margin-left:30px}.img-wrapper[_ngcontent-%COMP%]{float:left}.msg-wrapper[_ngcontent-%COMP%]{margin-left:12px}.success[_ngcontent-%COMP%]{height:22px;width:19px}.error[_ngcontent-%COMP%], .info[_ngcontent-%COMP%], .warning[_ngcontent-%COMP%]{height:20px;width:20px}.message[_ngcontent-%COMP%]{padding:0 12px;display:inline-block;word-wrap:break-word}.notification-error[_ngcontent-%COMP%]{background-color:#fbe5ed}.notification-success[_ngcontent-%COMP%]{background-color:#e3f1e3}.notification-warning[_ngcontent-%COMP%]{background-color:#fef8e4}.notification-info[_ngcontent-%COMP%]{background-color:#e3e0f1}.close-click[_ngcontent-%COMP%]{padding-right:30px;cursor:pointer;position:relative;font-size:26px;opacity:.7;color:#333;float:right}@media (max-width:888px){.notification[_ngcontent-%COMP%]{display:flow-root;height:inherit;position:relative;text-align:left;padding-left:10px;padding-top:15px;min-height:50px;font-size:16px;line-height:18px;color:#333}.sticky-top[_ngcontent-%COMP%]{position:fixed;top:0;overflow:hidden;z-index:10;width:100%}.message[_ngcontent-%COMP%]{max-width:250px;margin:auto;float:left;display:block;overflow:none}.close-click[_ngcontent-%COMP%]{padding-right:30px;cursor:pointer;position:relative;font-size:26px;opacity:.7;color:#333;float:right}}"] });
/** @nocollapse */
NotificationBarComponent.ctorParameters = () => [
    { type: NotificationService },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [MESSAGES_CONFIG,] }, { type: Optional }] }
];
NotificationBarComponent.propDecorators = {
    toast: [{ type: ViewChild, args: ['stickyToast', { static: false },] }],
    handleScroll: [{ type: HostListener, args: ['window:scroll', [],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NotificationBarComponent, [{
        type: Component,
        args: [{ selector: 'notification-bar', template: "<div #stickyToast [ngClass]=\"sticky?'sticky':'sticky-top'\">\n    <div *ngFor=\"let notification of notifications; let i = index;\"\n         class=\"notification notification-{{notification.typeValue}}\">\n        <div class=\"img-wrapper\">\n            <img src=\"/assets/{{notification.typeValue}}.png\" class=\"logo {{notification.typeValue}}\"/>\n        </div>\n        <div class=\"msg-wrapper\">\n            <div class=\"message\">{{notification.message}}</div>\n            <div class=\"close-click\" *ngIf=\"notification.allowClose\" (click)=\"hideNotification(notification)\">\u00D7</div>\n        </div>\n    </div>\n</div>\n", styles: [":host{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column}.sticky{position:fixed;top:0;overflow:hidden;z-index:10;width:100%}.sticky-top{position:fixed;top:60px;overflow:hidden;z-index:10;width:100%}.notification{position:relative;text-align:left;padding-left:50px;padding-top:15px;height:50px;font-size:16px;line-height:18px;color:#333}.logo{margin-left:30px}.img-wrapper{float:left}.msg-wrapper{margin-left:12px}.success{height:22px;width:19px}.error,.info,.warning{height:20px;width:20px}.message{padding:0 12px;display:inline-block;word-wrap:break-word}.notification-error{background-color:#fbe5ed}.notification-success{background-color:#e3f1e3}.notification-warning{background-color:#fef8e4}.notification-info{background-color:#e3e0f1}.close-click{padding-right:30px;cursor:pointer;position:relative;font-size:26px;opacity:.7;color:#333;float:right}@media (max-width:888px){.notification{display:flow-root;height:inherit;position:relative;text-align:left;padding-left:10px;padding-top:15px;min-height:50px;font-size:16px;line-height:18px;color:#333}.sticky-top{position:fixed;top:0;overflow:hidden;z-index:10;width:100%}.message{max-width:250px;margin:auto;float:left;display:block;overflow:none}.close-click{padding-right:30px;cursor:pointer;position:relative;font-size:26px;opacity:.7;color:#333;float:right}}"] }]
    }], function () { return [{ type: NotificationService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [MESSAGES_CONFIG]
            }, {
                type: Optional
            }] }]; }, { 
    /**
     * @return {?}
     */
    handleScroll: [{
            type: HostListener,
            args: ['window:scroll', []]
        }], toast: [{
            type: ViewChild,
            args: ['stickyToast', { static: false }]
        }] }); })();
if (false) {
    /** @type {?} */
    NotificationBarComponent.prototype.toast;
    /** @type {?} */
    NotificationBarComponent.prototype.sticky;
    /** @type {?} */
    NotificationBarComponent.prototype.elementPosition;
    /** @type {?} */
    NotificationBarComponent.prototype.notifications;
    /** @type {?} */
    NotificationBarComponent.prototype.defaults;
    /** @type {?} */
    NotificationBarComponent.prototype.subscription;
    /**
     * @type {?}
     * @private
     */
    NotificationBarComponent.prototype.notificationBarService;
    /**
     * @type {?}
     * @private
     */
    NotificationBarComponent.prototype.doc;
    /**
     * @type {?}
     * @private
     */
    NotificationBarComponent.prototype.config;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function NgxUxComponentsModuleConfig() { }
if (false) {
    /** @type {?} */
    NgxUxComponentsModuleConfig.prototype.namespace;
}
class NgxUxComponentsModule {
    /**
     * @param {?} config
     * @param {?} messagesConfig
     * @return {?}
     */
    static forRoot(config, messagesConfig) {
        return {
            ngModule: NgxUxComponentsModule,
            providers: [
                { provide: NAMESPACE_TOKEN, useValue: config.namespace },
                { provide: MESSAGES_CONFIG, useValue: messagesConfig },
                { provide: Window, useValue: window }
            ],
        };
    }
}
NgxUxComponentsModule.ɵfac = function NgxUxComponentsModule_Factory(t) { return new (t || NgxUxComponentsModule)(); };
NgxUxComponentsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxUxComponentsModule });
NgxUxComponentsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [NotificationService], imports: [CommonModule,
        TranslateModule,
        HttpClientModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxUxComponentsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    TranslateModule,
                    HttpClientModule,
                ],
                declarations: [GraphLoadBarComponent, IndeterminateLoadBarComponent, NotificationBarComponent, EllipsisTooltipDirective, OnHoverDirective],
                providers: [NotificationService],
                exports: [GraphLoadBarComponent, IndeterminateLoadBarComponent, NotificationBarComponent, EllipsisTooltipDirective, OnHoverDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxUxComponentsModule, { declarations: function () { return [GraphLoadBarComponent, IndeterminateLoadBarComponent, NotificationBarComponent, EllipsisTooltipDirective, OnHoverDirective]; }, imports: function () { return [CommonModule,
        TranslateModule,
        HttpClientModule]; }, exports: function () { return [GraphLoadBarComponent, IndeterminateLoadBarComponent, NotificationBarComponent, EllipsisTooltipDirective, OnHoverDirective]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { NgxUxComponentsModule, NotificationService, NotificationType, OnHoverDirective as ɵa, GraphLoadBarComponent as ɵb, NAMESPACE_TOKEN as ɵc, IndeterminateLoadBarComponent as ɵd, MESSAGES_CONFIG as ɵe, NotificationBarComponent as ɵf, EllipsisTooltipDirective as ɵh };

